module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAUCAIAAACMMcMmAAAAqUlEQVRIx2Ng0K6nOcIqyqpTSVs72HXL9G1caWUHq1qqpZ25qLqzkZmurI6drJ4rg1Y1le3Q1Fbqq1SuSJeJDxCvzZRrzJVjkPKjqh1atflJSrX58g2FCi3FiiWJcrmxUhb21lT2R3m2zo3tJh9OWx5foX99m/HxlQau/v5UtoPXoEBc04NB0JiBT4tfwdrAIYCGaZce+YPK6JygGq3RqB2jdozaMbB2AADx5DM8bFRINwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/li.png
// module id = 864
// module chunks = 0